import { ModalFooter } from 'reactstrap'
import ICSActionButton from '../../components/ICS/ActionButton/ICSActionButton'
import keyImg from '../Login/assets/key-fill.svg'
import { StrategyItem } from '../../redux/slices'
import { useSelector } from 'react-redux'
import { DefaultState } from '../../types'
import { LoadIndicator } from 'devextreme-react'
import { useNavigate } from 'react-router-dom'

const SSOItems = ({ ssoItems }: { ssoItems: StrategyItem[] }) => {
const { loading } = useSelector((state: DefaultState) => state.strategies)

  const handleClick = (sso_name: string) => {
      return  window.location.href = `/auth/authorization/login/${sso_name}`
  }

  if (loading) {
    return <LoadIndicator />
  } else {
    return (
      <>
        <ModalFooter className='sso-footer'>
        <h2 id='strategy_h2'>Or sign in with</h2>
          <ul id='strategy_container'>
            {ssoItems.map((sso, index) => {
              return (
                <li key={index}>
                  <ICSActionButton
                    type='default'
                    stylingMode='contained'
                    text={`${sso.name}`}
                    icon={keyImg}
                    height='auto'
                    onClick={() => {
                      handleClick(sso.name)
                    }}
                  />
                </li>
              )
            })}
          </ul>
        </ModalFooter>
      </>
    )
  }
}

export default SSOItems